// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"141":"960cbebbf38e7b38","282":"0f3d6dc7299df5ba","405":"8635177b96cd7903","888":"7bc705bc9b637dab"}[chunkId] + ".css";
};